export default ({ userIds }, data) => {
    return {
        liveStreamId: data.id,
        userIds: [...userIds],
        editType: 'users',
    }
}
